import React, { PureComponent } from "react";
import Highcharts from "highcharts";

import html2canvas from "html2canvas";
import moment from "moment-timezone";
import { downloadCSVData, downloadCanvasWithTitle, getViewConversationDuration } from "../utils";
import IntervalSelector from "../IntervalSelector";
import GeneralTrendsWithTopicsChart from "./GeneralTrendsWithTopicsChart";
import NoData from "../NoData/NoData";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import { connect } from "react-redux";
import DownloadChart from "../DownloadChart";
import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";

import { ReactComponent as ComparisionIcon } from "../../../../../assets/svg/CompareChartIcon.svg";
import * as d3 from "d3";

Highcharts.setOptions({
    lang: {
        numericSymbols: ["k", "m", "b", "t", "p", "e"],
        thousandsSep: ",",
    },
});

class GeneralTrendsWithTopics extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            downloadingCSV: false,
            show_unique_conversations: false,
        };
        this.chartEl = React.createRef();
    }

    formatData(data) {
        let dta = [];
        let totalXs = _.uniq([...data[0].xs, ...data[1].xs]).sort((a, b) => a - b);
        data[0].res.forEach((val) => {
            let dt = new Array(totalXs.length).fill(null);
            data[0].xs.forEach((t, i) => {
                let ind = totalXs.indexOf(t);

                if (this.state.show_unique_conversations) {
                    dt[ind] = val.uniqueValues[i];
                } else {
                    dt[ind] = val.values[i];
                }
            });
            if (dt[0] === null) dt[0] = 0;
            if (dt[dt.length - 1] === null) dt[dt.length - 1] = 0;

            dta.push([val.name].concat(dt));
        });
        let dt = new Array(totalXs.length).fill(null);

        data[1].xs.forEach((t, i) => {
            let ind = totalXs.indexOf(t);

            dt[ind] = data[1].vals[i];
        });

        dta.push(["General Trends"].concat(dt));
        dta.push(["xs"].concat(totalXs));

        return dta;
    }

    isHourly(data) {
        if (data.xs.length < 2) {
            if (data.xs.length < 2) return false;
            return data.xs[1] - data.xs[0] < 24 * 59 * 60 * 1000;
        }
        return data.xs[1] - data.xs[0] < 24 * 59 * 60 * 1000;
    }

    handleContextMenuClick(d) {
        let newFilter = this.props.filters ? JSON.parse(JSON.stringify(this.props.filters)) : {};

        if (d.series.userOptions.allSubtopicSelected === "others") {
            newFilter.topics = d.series.userOptions.topicId;
            newFilter.subtopics = d.series.userOptions.subtopicIds;
        } else if (d.series.userOptions.allSubtopicSelected) {
            newFilter.topics = [d.series.userOptions.topicId];
            newFilter.subtopics = [];
        } else {
            newFilter.topics = [];
            newFilter.subtopics = d.series.userOptions.subtopicIds;
        }

        let lastComparisonIndex = false;
        lastComparisonIndex = d.index === d.series.points.length - 1 && d.color.endsWith("55");

        newFilter = getViewConversationDuration(
            d,
            newFilter,
            this.props.aggs_val,
            this.props.filters,
            this.props.comparisionData,
            lastComparisonIndex,
            this.props.comparisonAppliedFilter,
        );

        this.props.handleContextMenuClick(newFilter);
    }

    addContextMenuListener = (x, y, chart) => {
        if (this.props.isPublic) return;
        let self = this;
        let contextMenu = d3.select(".dashboard-charts-contextmenu");

        contextMenu.attr("data-type", "clickedMenu");
        contextMenu.style("top", `${y + 10}px`);
        contextMenu.style("left", `${x - 82}px`);
        contextMenu.style("background", `#fff`);
        contextMenu.style("color", `#1a1a1a`);
        contextMenu.html(null);
        contextMenu
            .append("li")
            .text("View Conversations")
            .on("click", () => {
                self.handleContextMenuClick(chart);
            });
        contextMenu.style("display", "block");
    };

    downloadPNG = (cb, options) => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }

        html2canvas(this.chartEl.current, { backgroundColor: options.background ? "#fff" : null, allowTaint: true, useCORS: true }).then((canvas) => {
            cb && cb();

            downloadCanvasWithTitle(canvas, this.props.widget.name);
        });
    };

    downloadCSV = () => {
        if (this.props.isFreeTierPackage) {
            this.props.packageUpgradePopup();
            return;
        }

        let data = this.formatData(this.props.data.responseObj);
        let comparisonCSVData = this.props.comparisionData && this.formatData(this.props.comparisionData.responseObj);
        let formatString = "YYYY-MM-DD HH:mm";
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let comparisoncsvFmt;
        let csvFmt;

        [data[data.length - 1], data[0]] = [data[0], data[data.length - 1]];
        data[0] = data[0].map((d) => (d === "xs" ? "Time" : moment(d).tz(tz).format(formatString)));

        if (this.props.comparisionData) {
            [comparisonCSVData[comparisonCSVData.length - 1], comparisonCSVData[0]] = [comparisonCSVData[0], comparisonCSVData[comparisonCSVData.length - 1]];
            comparisonCSVData[0] = comparisonCSVData[0].map((d) => (d === "xs" ? "Comparison Time" : moment(d).tz(tz).format(formatString)));

            // comparisonCSVData.map((ele, ind) => {
            //     if (ind > 0) ele[0] = "Comparison " + ele[0];
            // });
        }

        csvFmt = data[0].map((col, i) => data.map((row) => row[i]));
        if (this.props.comparisionData) {
            comparisoncsvFmt = comparisonCSVData[0].map((col, i) => comparisonCSVData.map((row) => row[i]));
            csvFmt.push(...comparisoncsvFmt);
        }

        let firstIndLen = csvFmt[0].length;
        let lastIndLen = csvFmt[csvFmt.length - 1].length;

        let length;
        if (firstIndLen > lastIndLen) length = firstIndLen;
        else length = lastIndLen;

        let arr = [];
        for (let i = 0; i < length; i++) {
            arr.push([]);
            for (let j = 0; j < csvFmt.length; j++) {
                if (csvFmt[j] && csvFmt[j][i]) arr[i].push(csvFmt[j][i]);
                else arr[i].push(0);
            }
        }

        downloadCSVData(arr, this.props.widget.name);
    };

    renderDownloadButton(nodata) {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: this.downloadCSV },
                    {
                        name: "PNG",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: true,
                    },
                    {
                        name: "PNG(Transparent)",
                        downloadFn: this.downloadPNG,
                        showLoader: true,
                        background: false,
                    },
                ]}
            />
        );
    }

    toggleTopicUniqueConversations(d) {
        this.setState({ show_unique_conversations: !this.state.show_unique_conversations });
    }

    handleIntervalChange = (val) => {
        this.props.handleIntervalChange(val);
    };

    render() {
        let nodata = !this.props.data || (this.props.data && this.props.data.nodata) || this.props.noTopicsSelected;

        return (
            <>
                <div className="dashboard-widget-container-header skiptranslate">
                    <ChartName
                        name={this.props.widget.name}
                        info="Shows the general trend line plotted against the volume of conversation of the selected topics in the filter. Note! Chart Comparison will not apply on others legend."
                    />
                    <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                        {this.props.dashboardPageType !== "temporaryInsights" && this.props.dashboardPageType !== "temporary" && (
                            <Popup
                                content="Chart Comparison Filters"
                                position="bottom center"
                                size="tiny"
                                inverted
                                className="skiptranslate"
                                trigger={
                                    <div className={`chart-header-icon`} onClick={() => (!this.props.isPublic ? this.props.chartComparision() : null)}>
                                        <ComparisionIcon className={`comparision-filter${this.props.chartComparisionFilterApplied ? "-applied" : ""}`} />
                                    </div>
                                }
                            />
                        )}
                        {!this.props.isPublic &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <ChartFilterIcon
                                    chartFilterApplied={this.props.chartFilterApplied}
                                    changeShowChartFilterOptions={this.props.changeChartFilter}
                                    widgetListDashboardCurrent={this.props.widgetListDashboardCurrent}
                                    name={this.props.widget.name}
                                />
                            )}
                        {!this.props.isPublic && this.renderDownloadButton(nodata)}
                        {
                            <>
                                {this.props.isPublic && nodata ? null : (
                                    <Popup
                                        className="skiptranslate"
                                        trigger={
                                            this.props.expandWidget ? (
                                                <MiniMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            ) : (
                                                <MaxiMize className="chart-header-icon" onClick={this.props.expandFullWidget} />
                                            )
                                        }
                                        inverted
                                        content={this.props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                        size="mini"
                                        position="bottom center"
                                        style={{ zIndex: "99999" }}
                                    />
                                )}
                            </>
                        }
                        {this.props.isPublic && nodata ? null : <MoreOptions className="more-options" onClick={(e) => this.props.changeShowMoreOptions(e)} />}
                    </div>
                </div>
                {this.props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={this.props.showMoreOptionsLoc}
                        changeShowMoreOptions={this.props.changeShowMoreOptions}>
                        {!nodata && <CustomCheckBox checked={this.props.showLegend} onClick={this.props.changeShowLegend} label="Show Legends" />}
                        {!nodata && <CustomCheckBox label="Show Grid Lines" checked={this.props.showGridLines} onClick={this.props.changeShowGridLines} />}
                        {!nodata && (
                            <IntervalSelector
                                aggs_val={this.props.aggs_val}
                                appliedFilter={this.props.appliedFilter}
                                handleIntervalChange={this.props.handleIntervalChange}
                                disableComparisonInterval={this.props.disableComparisonInterval}
                            />
                        )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={this.props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={this.props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                </>
                            )}
                        {!this.props.isPublic &&
                            !this.props.isStandardDashboard &&
                            !this.props.isResearchDashboard &&
                            this.props.dashboardPageType !== "temporaryInsights" &&
                            this.props.dashboardPageType !== "temporary" && <DeleteWidget onClick={this.props.deleteWidget} />}
                    </ChartOptionsSidebar>
                )}

                {!nodata ? (
                    <div className="dashboard-chart skiptranslate moment-overtime" ref={this.chartEl}>
                        <GeneralTrendsWithTopicsChart
                            data={this.props.data}
                            addContextMenuListener={this.addContextMenuListener}
                            // resizedCount={this.props.resizedCount}
                            showLegend={this.props.showLegend}
                            showGridLines={this.props.showGridLines}
                            comparisionData={this.props.comparisionData}
                            widgetContainerRef={this.props.widgetContainerRef}
                            legendClick={this.props.legendClick}
                            expandWidget={this.props.expandWidget}
                        />
                    </div>
                ) : (
                    <NoData
                        message={
                            !this.props.isPublic && this.props.noTopicsSelected
                                ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                                : null
                        }
                    />
                )}
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        // allPlatforms: state.globalReducer.filterOptions ? state.globalReducer.filterOptions.platforms : [],
        allPlatforms: state.filterSettingReducer.masterPlatforms,
        widgetListDashboardCurrent: state.dashboardReducer.widgetListDashboardCurrent,
        maximizeWidgetValue: state.dashboardReducer.maximizeWidgetValue,
    };
}

export default connect(mapStateToProps)(GeneralTrendsWithTopics);
